const UiButtonPropsOption = {
  nativeType: { type: String, default: "button" },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  simple: { type: Boolean, default: false },
  width: { type: [String, Number] },
  type: { type: String, default: "info" },
  size: { type: String, default: "default" }
};
const UiButtonEmits = {
  click: (_ev) => true
};

export { UiButtonEmits, UiButtonPropsOption };
//# sourceMappingURL=index.mjs.map
